module.exports = __webpack_public_path__ + "img/90sheji_linggan_13648585@2x.20432b1c.png";